export namespace Permissions {
  export enum PermissionsList {
    ReadTransactions = 'read:transactions',
    DownloadTransactions = 'download:transactions',
    ManageTransactions = 'manage:transactions',
    ReadStatusService = 'read:status-service',
    ReadP2mInfo = 'read:p2m-info',
  }
}
